const SharingLevelsMapping = Object.freeze({
  0: 'Not Approved',
  1: 'Approved',
  2: 'Pending'
});
export default SharingLevelsMapping;